<template>
  <el-card class="myLesson">
    <div class="tabs flex-layout">
      <p @click="tabsClick(0)" :class="{active:0===isActive}">學習中</p>
      <p @click="tabsClick(1)" :class="{active:1===isActive}">
        <el-badge :value="$store.state.user.computed" :max="99" :hidden="$store.state.user.computed==0" style="width:100%">
          已完成
        </el-badge>
      </p>
      <p @click="tabsClick(2)" :class="{active:2===isActive}">已評價</p>
    </div>
    <el-row v-loading="loading" style="height:460px">
      <Learning :lessonData="data" v-show="tabs === 0" />
      <Completed :lessonData="data" v-show="tabs === 1" @getMyCourse="getMyCourse" />
      <Evaluated :lessonData="data" v-show="tabs === 2" />
    </el-row>
    <div class="page">
      <el-pagination v-if="pageshow" background hide-on-single-page @current-change="currentChange" :current-page="page" layout="prev, pager, next" :total="totalLength" :page-size="10">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>

import Learning from './myLesson/learning.vue';
import Completed from './myLesson/completed.vue';
import Evaluated from './myLesson/evaluated.vue';
export default {
  components: { Learning, Completed, Evaluated },
  data () {
    return {
      data: [],
      tabs: 0,
      isActive: 0,
      page: 1,
      totalLength: 0,
      loading: false,
      pageshow: true
    }
  },
  created () {
    this.getMyCourse('study', 1)
    this.getComputedNum('completed', 1)
  },
  methods: {
    async getMyCourse (type, page) {
      this.loading = true;
      await this.$http.personal.getMyCourse({ type: type, page: page, page_size: 10 }).then(res => {
        this.loading = false;
        if (res.status === 200) {
          let resData = res.data.data;
          this.totalLength = resData.total;
          this.data = resData.data;
          this.$emit('goAnchor', '#anchor1')
          this.$emit('countNum')
          if (type == 'completed') {
            this.$store.commit('setComputed', res.data.data.total)
          }
          if (type != 'study') {
            this.getEvaluate(0)
          }
        }
      }).catch(v => {
        this.loading = false;
      })
    },
    async getComputedNum (type, page) {
      await this.$http.personal.getMyCourse({ type: type, page: page, page_size: 1 }).then(res => {
        if (res.status === 200) {
          this.$store.commit('setComputed', res.data.data.total)
        }
      }).catch(v => { })
    },
    async getEvaluate (index) {
      if (index >= this.data.length) return;
      await this.$http.personal.getEvaluate({ courseId: this.data[index][0].id }).then(res => {
        if (res.status === 200) {
          this.data[index].rate = Number(res.data.data.evaluate.toFixed(1));
          this.getEvaluate(index + 1)
        }
      }).catch(v => { })
    },
    tabsClick (i) {
      this.isActive = i;
      this.tabs = i;
      this.page = 1;
      this.pageshow = false;
      this.$nextTick(() => {
        this.pageshow = true;
      });
      if (i === 0) {
        this.getMyCourse('study', 1)
      } else if (i === 1) {
        this.getMyCourse('completed', 1)
      } else {
        this.getMyCourse('evaluated', 1)
      }
    },
    currentChange (page) {
      this.page = page;
      if (this.isActive === 0) {
        this.getMyCourse('study', page)
      } else if (this.isActive === 1) {
        this.getMyCourse('completed', page)
      } else {
        this.getMyCourse('evaluated', page)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tabs {
  background-color: #f2f2f8;
  p {
    width: 107px;
    height: 36px;
    background-color: #fff;
    text-align: center;
    line-height: 36px;
    font-size: 16px;
    color: #333;
    margin: 15px 20px 15px 30px;
    border-radius: 3px;
    cursor: pointer;
  }
  p:hover {
    background-color: #4d8ef6;
    color: #fff;
  }
  .active {
    background-color: #4d8ef6;
    color: #fff;
  }
}
.page {
  display: flex;
  justify-content: center;
}
</style>